import React from 'react';
import { Download } from 'react-feather';
import styles from './styles/ToggleButton.module.scss';
import { PencilEditIcon } from 'components/svgs/PencilEditIcon';

interface IProps {
  id?: string;
  buttonText?: React.ReactNode;
  className?: string;
  toggled: boolean;
  onClick(...args): void;
}

const ToggleButton = ({
  id,
  buttonText = 'Edit',
  className,
  toggled,
  onClick,
}: IProps) => {
  return (
    <div className={classnames(styles.container, className)}>
      {toggled ? (
        <>
          <Download size={16} className={styles.download} />
          <button className={styles.save} type="submit">
            Save
          </button>
        </>
      ) : (
        <>
          <PencilEditIcon className={styles.pencil} />
          <button
            id={id}
            className={styles.edit}
            type="button"
            onClick={onClick}
          >
            {buttonText}
          </button>
        </>
      )}
    </div>
  );
};

export default ToggleButton;
